import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { QUERY_PARAMS } from '@futrli/shared-services';
import { toastError } from '@futrli/ui-components';

export const useShowIncorrectBusinessIdError = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const sage50Error = searchParams.get(QUERY_PARAMS.SAGE_50_ERROR);

  // Sage50 users might end in the error state. Frontend redirects them to the specific page
  // with additional query param - QUERY_PARAMS.SAGE_50_ERROR. If that query param is in
  // the URL, frontend will display error
  useEffect(() => {
    if (sage50Error === 'true') {
      toastError(
        <FormattedMessage
          id="organisations.supplied_business_reference_not_found"
          defaultMessage="The supplied business reference was not found or you do not have the correct permissions."
        />
      );
    }
  }, [sage50Error]);
};
